import React, { useState } from "react";
import { Button, FormControl, TextField, Typography } from "@mui/material";
import { useAuth } from "../../context/API_Client";
import ForgotPasswordOTP from "./forgotPasswordOTP";
import "./login.css";
import CustomButton from "../../reusableComponents/CustomButton";
import { emailRegex } from "../../reusableComponents/constants";

function ForgotPassword({ forgotPasswordEmail, onBackToLogin, mobileLayout }) {
  const { credentialsCheck } = useAuth();
  const [email, setEmail] = useState(forgotPasswordEmail);
  const [showOTPForm, setShowOTPForm] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [emailExists, setEmailExists] = useState(true);
  const [error, setError] = useState();
  const [showResetPassword, setshowResetPassword] = useState(false);
  const [otp, setOtpValue] = useState("");

  const [edit, setEdit] = useState(false);

  const handleOTPChange = (otp) => {
    setOtpValue(otp);
  };

  const showReset = (showResetPassword) => {
    setshowResetPassword(showResetPassword);
  };

  const handleOTP = () => {
    if (validateEmail(email)) {
      setEmailError(false);
      checkEmailExists(email);
    } else {
      setEmailError(true);
    }
  };

  const validateEmail = (email) => {
    return emailRegex.test(email);
  };

  const checkEmailExists = (email) => {
    credentialsCheck(
      { email },
      (data) => {
        setShowOTPForm(true);
        setEdit(true);
      },
      (errorMsg, status) => {
        if (status === 404) {
          setError("Please enter a valid email address");
        } else {
          setError(errorMsg);
        }

        setShowOTPForm(false);
        setEmailExists(false);
      }
    );
  };

  const editBackButton = (edit) => {
    setEdit(edit);
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="back-to-login" onClick={onBackToLogin}>
        <img src="/assets/arrowNarrowLeft.svg" alt="Arrow" />
        Back to Login
      </div>

      {edit ? (
        <>
          <ForgotPasswordOTP
            title={"Forgot Password"}
            subtitle={"We have sent a verification code to"}
            email={email}
            showReset={showReset}
            onOTPChange={handleOTPChange}
            editBackButton={editBackButton}
            mobileLayout={mobileLayout}
            creating={false}
          />
        </>
      ) : (
        <div>
          <Typography
            sx={{ marginTop: mobileLayout ? "19px" : "23px" }}
            className="login-main-title1"
          >
            Forgot Password
          </Typography>
          <Typography className="login-main-title2">
            Enter registered email address
          </Typography>

          <TextField
            sx={{
              marginTop: mobileLayout ? "20px" : "48px",
            }}
            fullWidth
            id="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(false);
              setEmailExists(true);
            }}
            error={emailError || !emailExists}
          />
          <div
            style={{
              minHeight: "50px",
              display: "flex",
              alignItems: "center",
              marginTop: "4px",
            }}
          >
            {error && (
              <div className="email-error">
                <img src="/assets/errorOutline.svg" alt="Error" />
                <Typography
                  className="labelRegularRes"
                  sx={{
                    color: "var(--Comms-Negative, #B9232F) !important",
                  }}
                >
                  {error}
                </Typography>
              </div>
            )}
          </div>
          <CustomButton
            variant={"contained"}
            width={"100%"}
            color="primary"
            size={mobileLayout ? "xxl" : "xxxl"}
            text={"Request verification code"}
            onClick={handleOTP}
            disabled={!validateEmail(email)}
          />
        </div>
      )}
    </div>
  );
}

export default ForgotPassword;
